export default () => ({
    playing: false,
    videoProgress: 0,
    videoLoaded: {
        non_desktop: null,
        desktop: null
    },
    videoElements: {
        non_desktop: null,
        desktop: null
    },
    innerWidth: window.innerWidth,
    abortController: new AbortController(),
    get bothVideoLoaded() {
        return this.videoLoaded.desktop && this.videoLoaded.non_desktop;
    },
    handleVideoLoaded(event) {
        const isDesktop = event.detail.isDesktop

        if (isDesktop) {
            this.videoLoaded.desktop = true;
        } else {
            this.videoLoaded.non_desktop = true;
        }
    },
    handleTimeUpdate(element) {
        if (!element) {
            return;
        }

        this.videoProgress = (element.currentTime / element.duration) * 100;

        if (this.videoProgress === 100) {
            this.playing = false;
        }
    },
    handleResize() {
        const wasPlaying = this.playing;
        const wasDesktop = this.innerWidth >= 1024;
        this.innerWidth = window.innerWidth;
        const isDesktop = this.innerWidth >= 1024;

        if (!wasPlaying) {
            return;
        }

        if (wasDesktop && !isDesktop) {
            this.pauseAndSync(this.videoElements.desktop);
            return;
        }

        if (!wasDesktop && isDesktop) {
            this.pauseAndSync(this.videoElements.non_desktop);
        }
    },
    restartVideo(video) {
        video.currentTime = 0;
        this.videoProgress = 0;
    },
    play() {
        const finished = this.videoProgress === 100;

        const nonDesktopEl = this.videoElements.non_desktop;
        const desktopEl = this.videoElements.desktop;

        if (finished) {
            this.restartVideo(nonDesktopEl);
            this.restartVideo(desktopEl);
        }

        if (this.innerWidth >= 1024) {
            nonDesktopEl.muted = true;
            desktopEl.muted = false;

            desktopEl.play();
        } else {
            nonDesktopEl.muted = false;
            desktopEl.muted = true;

            nonDesktopEl.play();
        }

        this.playing = true;
    },
    pauseAndSync(prevVideoPlayer) {
        const nonDesktopEl = this.videoElements.non_desktop;
        const desktopEl = this.videoElements.desktop;

        nonDesktopEl.pause();
        desktopEl.pause();

        const currentTime = prevVideoPlayer.currentTime;

        nonDesktopEl.currentTime = currentTime;
        desktopEl.currentTime = currentTime;

        this.playing = false;
    },
    pause() {
        const nonDesktopEl = this.videoElements.non_desktop;
        const desktopEl = this.videoElements.desktop;

        nonDesktopEl.pause();
        desktopEl.pause();

        this.playing = false;
    },
    toggleAction() {
        if (this.playing) {
            this.pause();
        } else {
            this.play();
        }
    },
    init() {
        this.$nextTick(() => {
            const elements = document.querySelectorAll('[data-video]');

            elements.forEach(el => {
                this.videoElements[el.dataset.videoFor] = el;
            });

            this.videoElements.desktop.addEventListener(
                'timeupdate',
                () => this.handleTimeUpdate(this.videoElements.desktop),
                {signal: this.abortController.signal}
            );

            this.videoElements.non_desktop.addEventListener(
                'timeupdate',
                () => this.handleTimeUpdate(this.videoElements.non_desktop),
                {signal: this.abortController.signal}
            );
        });

        window.addEventListener(
            'resize',
            Alpine.debounce(e => this.handleResize(e), 300),
            {signal: this.abortController.signal}
        );
    },
    destroy() {
        this.abortController.abort();
    }
})
